import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { firstAccessiblePath } from "../constants/permissionKeys";
import { useAccess } from "../context/AccessProvider";

export default function AccessDenied() {
  const navigate = useNavigate();
  const { can } = useAccess();
  return <Result status="403" title="Access denied" subTitle="Your current access preset does not allow this page." extra={<Button type="primary" onClick={() => navigate(firstAccessiblePath(can), { replace: true })}>Go to an accessible page</Button>} />;
}
